import { render, staticRenderFns } from "./headerPhone.vue?vue&type=template&id=3566eae2&scoped=true&"
import script from "./headerPhone.vue?vue&type=script&lang=js&"
export * from "./headerPhone.vue?vue&type=script&lang=js&"
import style0 from "./headerPhone.vue?vue&type=style&index=0&id=3566eae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3566eae2",
  null
  
)

export default component.exports